<template>
  <div class="sticky-container">
    <div class="hero is-large is-primary main-hero" ref="hero"
         @drop="handleDrop($event)"
         :class="{'is-sticky': isSticky, 'is-processing': isUploadProcessing, 'is-checkout': isCheckout, 'is-pulsating': isFileDragging}"
         :style="{'top': (isSticky ?  112 + heightToStickAt: 0) + 'px'}">
      <img alt="Hero Banner" :src="backgroundImage" class="main-hero__image"
           v-if="[orderProcess.STEPS.NO_ORDER_ONGOING, orderProcess.STEPS.ORDER_COMPLETED].includes(currentOrderProcessStep)">

      <div class="hero-body main-hero__body">
        <!-- <div class="container" v-if="!isCheckout"> -->
        <!--   <h1 class="title is-1 has-text-black">{{$t('checkout.upload.defaultHeader')}}</h1> -->
        <!--   <h2 class="title is-2 has-text-black">{{ pageSubtitle }}</h2> -->
        <!--   <div v-if="isUploadProcessing" key="upload-spinner" -->
        <!--        class="container is-loading"> -->
        <!--   </div> -->
        <!--   <div class="is-size-4 mt-3">{{ fileUploadState.message }}</div> -->
        <!---->
        <!-- </div> -->
      </div>
      <!-- <div v-show="!isCheckout" -->
      <!--      class="hero-foot main-hero__footer" -->
      <!--      ref="heroFooter"> -->
      <!--   <div class="container"> -->
      <!--     <div class="columns is-centered"> -->
      <!--       <div class="column is-one-fifth"> -->
      <!--         <a class="icon upload-icon btn-upload-3d-file" @click="selectFile"> -->
      <!--           <img src="@/assets/img/lnr-upload-white.svg"> -->
      <!--         </a> -->
      <!--       </div> -->
      <!--       <div class="column is-three-fifths upload-actions"> -->
      <!--         <p class="upload title is-size-5-widescreen is-size-5-desktop" v-if="supportsDragAndDrop"> -->
      <!--           {{$t('checkout.upload.dragAndDrop3DFile')}} -->
      <!--         </p> -->
      <!--         <p class="is-size-5" v-if="supportsDragAndDrop "> -->
      <!--           {{$t('checkout.upload.or')}} -->
      <!--         </p> -->
      <!--         <input @change="processFile(null)" type="file" id="3d-file" hidden ref="fileInput"> -->
      <!---->
      <!--         <a @click="selectFile" -->
      <!--            class="button is-primary-dark btn-upload-3d-file">{{ $t('checkout.upload.choose3DFile') }}</a> -->
      <!---->
      <!--       </div> -->
      <!--       <div class="column is-one-fifth"> -->
      <!--       </div> -->
      <!--     </div> -->
      <!--   </div> -->
      <!-- </div> -->
      <div v-if="isUploadProcessing" class="upload-progress">
        <div class="mas-progress" :style="{width: uploadProgress + '%'}"></div>
      </div>
    </div>
    <div class="sticky-container__placeholder" ref="stickyPlaceholder" v-if="isSticky"
         :style="{'height': heroHeight + 'px'}"></div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {orderProcess} from "../../store/constants/order-process";
import {eventBus} from "../../events/event-bus";

export default {
  name: "MainHero",
  data() {
    return {
      isSticky: false,
      headerHeight: 112,
      heroFooterHeight: 0,
      heroHeight: 0,
      isUploadProcessing: false,
      orderProcess: orderProcess,
      supportsDragAndDrop: false,
      isFileDragging: false,
      fileUploadState: "",
      uploadProgress: 0,
    }
  },
  computed: {
    ...mapGetters(['cmsPage', 'screenSize']),
    currentOrderProcessStep: {
      get() {
        return this.$store.getters['currentOrderProcessStep'];
      },
      set(orderProcessStep) {
        this.$store.dispatch('setCurrentOrderProcessStep', orderProcessStep);
      }
    },
    isCheckout() {
      return [orderProcess.STEPS.CONFIGURE_MODEL].includes(this.currentOrderProcessStep);
    },
    heightToStickAt() {
      return -(this.heroHeight - this.heroFooterHeight);
    },
    backgroundImage() {
      if (this.cmsPage.page && this.cmsPage.page.resources.media.length > 0) {
        return this.cmsPage.page.resources.media[0].publicUrl;
      }
      return require(`@/assets/img/BannerImage.jpg`);
    },
    pageSubtitle() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.meta.subtitle;
      }
      return "";
    }
  },
  methods: {
    setUpEventListeners() {
      let vm = this;
      if (window.FormData && window.FileReader) {
        vm.supportsDragAndDrop = true;

        ["drag", "dragstart", "dragend", "dragover", "dragenter", "dragleave", "drop"].forEach(eventType => {
          window.addEventListener(eventType, (event) => {
            event.preventDefault();
            event.stopPropagation();
          })
        });

        ["dragenter", "dragover"].forEach(eventType => {
          window.addEventListener(eventType, (event) => {
            vm.isFileDragging = vm.dragEventContainFiles(event)
          })
        });

        ["dragleave", "drop"].forEach(eventType => {
          window.addEventListener(eventType, (event) => {
            vm.isFileDragging = false;
          })
        })
      }
    },
    dragEventContainFiles(dragEvent) {
      if (dragEvent.dataTransfer.types) {
        for (let i = 0; i < dragEvent.dataTransfer.types.length; i++) {
          if (dragEvent.dataTransfer.types[i] === "Files") {
            return true;
          }
        }
      }

      return false;
    },
    handleDrop(event) {
      event.preventDefault();
      this.processFile(event.dataTransfer.files[0]);
    },
    selectFile() {
      let clickEvent = new MouseEvent("click", {
        "view": window,
        "bubbles": true,
        "cancelable": false
      });
      this.$refs.fileInput.dispatchEvent(clickEvent);
    },
    processFile(file) {
      window.scrollTo({top: 0, behavior: "smooth"});
      let vm = this;
      vm.isUploadProcessing = true;
      vm.file = file || this.$refs.fileInput.files[0];


      vm.$store.dispatch("upload3DFile", {file: vm.file}).then(() => {
        vm.isUploadProcessing = false;
        vm.currentOrderProcessStep = orderProcess.STEPS.CONFIGURE_MODEL;
        vm.$store.dispatch('setCheckoutVisibility', true);
      }).catch(() => {
        vm.isUploadProcessing = false;
        vm.currentOrderProcessStep = orderProcess.STEPS.NO_ORDER_ONGOING;
      });


    },
    showFileUploadState(message) {
      this.fileUploadState = message;
    },
    evaluateStickyness() {
      let scrollPosition = window.pageYOffset;
      this.adjustHeights();
      this.isSticky = scrollPosition >= -this.heightToStickAt;
    },
    adjustHeights() {
      this.heroHeight = this.$refs.hero.offsetHeight;
      this.heroFooterHeight = this.$refs.heroFooter.offsetHeight;
    },
    attachEventListeners() {
      window.addEventListener("scroll", this.evaluateStickyness, {passive: true});
      window.addEventListener("resize", this.adjustHeights);
    },
    removeEventListeners() {
      window.removeEventListener("scroll", this.evaluateStickyness);
      window.removeEventListener("resize", this.adjustHeights)
    }
  },
  created() {
    this.attachEventListeners();
    let vm = this;
    eventBus.$on('fileUploadStateChanged', (message) => {
          vm.showFileUploadState(message);
        }
    );
    eventBus.$on('fileUploadProgress', (progress) => {
      vm.uploadProgress = progress;
    });

    eventBus.$on('fileUploadAborted', () => {
      vm.isUploadProcessing = false;
      vm.fileUploadState = "";
      vm.uploadProgress = 0;
    })
  },
  mounted() {
    this.heroHeight = this.$refs.hero.offsetHeight;
    this.heroFooterHeight = this.$refs.heroFooter.offsetHeight;
    this.setUpEventListeners();
  },
  destroyed() {
    this.removeEventListeners();
  }
}
</script>
